module.exports = __webpack_public_path__ + "media/images/screens/06_listeProduits-40ef1e6293775fed13bd2e9cb76c1d30.jpg";